import React from 'react'
import { GridRow, GridCell } from '@mobi/component-library/Legacy/Grid'
import { ActiveCampaignsComponent } from './ActiveCampaign'
import { MysteryBonusButtonStyled } from '../Buttons/BonusBetButton.styles'

type BonusCashCampaignProps = {
  defaultValue: boolean
  toggleCampaign: (isApplied: boolean) => void
}

export function BonusCashCampaign({ defaultValue, toggleCampaign }: BonusCashCampaignProps) {
  const [useBonusCash, setUseBonusCash] = React.useState(defaultValue)

  const handleBonusHandler = () => {
    const newState = !useBonusCash
    setUseBonusCash(newState)
    toggleCampaign(newState)
  }

  return (
    <GridRow padding='0.5rem 0.5rem 0 0.5rem'>
      <GridCell>
        {!useBonusCash ? (
          <MysteryBonusButtonStyled onClick={handleBonusHandler}>
            Use My Bonus
          </MysteryBonusButtonStyled>
        ) : (
          <ActiveCampaignsComponent
            handleRemoveBonusCashButtonClick={handleBonusHandler}
          ></ActiveCampaignsComponent>
        )}
      </GridCell>
    </GridRow>
  )
}
